import {
  CardHeader,
  Checkbox,
  Chip,
  Divider,
  Stack,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import {
  blue,
  cyan,
  deepPurple,
  green,
  indigo,
  lightBlue,
  lightGreen,
  lime,
  pink,
  purple,
  red,
  teal,
} from "@mui/material/colors";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CardMenu from "./CardMenu";
import { removeGroup } from "../../services/group/groupApi";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { deleteGroup, selectMembers } from "../../features/daoTrang/daoTrangSlice";
import { UserChip } from "../To/UserChip";
export const areaColors = [
  red[100],
  pink[100],
  purple[100],
  deepPurple[100],
  indigo[100],
  blue[100],
  lightBlue[100],
  cyan[100],
  teal[100],
  green[100],
  lightGreen[100],
  lime[100],
];

export const BasicCard = ({ group, onCheck, index = 0, navigate }) => {
  const users = useAppSelector(selectMembers);
  const map = new Map();
  users.forEach((u) => map.set(u.email, u));

  const theme = createTheme({
    components: {
      // Name of the component
      MuiCardHeader: {
        styleOverrides: {
          // The props to change the default for.
          content: {
            textAlign: "center",
          }, // No more ripple, on the whole application 💣!
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundColor: areaColors[index % areaColors.length],
          },
        },
      },
    },
  });
  var { checked = false, name } = group;
  const {id:groupId} = group;
  const dispatch = useAppDispatch();

  const options = [
    {
      onClick: () => {
        navigate("BcsEdit", { groupsId: [group.id] });
      },
      icon: <EditIcon fontSize="small" />,
      label: "Edit",
    },
    {
      onClick: async () =>{
        const {error} = await removeGroup(groupId);
        if (!error) {
          dispatch(deleteGroup({groupId}))
        } else {
          console.log(error)
        }
      },
      icon: <DeleteForeverIcon fontSize="small" />,
      label: "Delete",
    },
  ];
  const checkBtn = <Checkbox
    sx={{ alignSelf: "flex-start" }}
    checked={checked}
    onClick={() => onCheck(index, !checked)}
  />;
  return (
    <ThemeProvider theme={theme}>
      <Card sx={{ minWidth: 275, maxWidth: 150, position:"relative" }}>
        <div style={{position:"absolute", bottom:"0px", right:"0px"}}>
          {checkBtn}
        </div>
        <CardHeader
          title={<Typography variant="h5">{name}</Typography>}
          action={CardMenu(options)}
        ></CardHeader>
        <CardContent>
          {group.subGroups.map(({ name, members }, i) => {
            return (
              <div key={i}>
                <Divider>{name}</Divider>
                <Stack
                  spacing={1}
                  direction={"row"}
                  
                  flexWrap={"wrap"}
                >
                  {members.map((email, i) => (
                    <UserChip key={i} user={map.get(email)}></UserChip>
                  ))}
                </Stack>
              </div>
            );
          })}
        </CardContent>
      </Card>
    </ThemeProvider>
  );
}
